import React from 'react';
import { useIntl } from 'ha/i18n';
import Track from 'ha/components/track/SmartTrack';
import FacebookIcon from 'streamline-icons/social-media-facebook-1.svg';
import { Button, Link } from '@ha/dsl';

export interface Props {
  trackName?: string;
  searchParams?: Record<string, unknown>;
}

const FacebookAuthBtn: React.FC<Props> = ({
  searchParams = {},
  trackName = 'Clicked Log in with Facebook',
  children,
}) => {
  const { urlResolver } = useIntl();
  const link = urlResolver.getFbAuthUrl(searchParams);

  return (
    <Track name={trackName} type="button">
      <Link to={link} data-test-locator="Continue with Facebook">
        <Button
          size="large"
          startIcon={<FacebookIcon htmlColor="#4267b2" />}
          variant="outlined"
          fullWidth
        >
          {children}
        </Button>
      </Link>
    </Track>
  );
};

export default FacebookAuthBtn;
